import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { PaymentReversalInfo } from '../fragments';

export default gql`
  mutation CreatePaymentReversal($input: PaymentReversalCreateInput!) {
    createPaymentReversal(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      paymentReversal {
        ...PaymentReversalInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${PaymentReversalInfo}
`;
